<!--
   The MIT License

   Copyright (c) 2019- Nordic Institute for Interoperability Solutions (NIIS)
   Copyright (c) 2018 Estonian Information System Authority (RIA),
   Nordic Institute for Interoperability Solutions (NIIS), Population Register Centre (VRK)
   Copyright (c) 2015-2017 Estonian Information System Authority (RIA), Population Register Centre (VRK)

   Permission is hereby granted, free of charge, to any person obtaining a copy
   of this software and associated documentation files (the "Software"), to deal
   in the Software without restriction, including without limitation the rights
   to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   copies of the Software, and to permit persons to whom the Software is
   furnished to do so, subject to the following conditions:

   The above copyright notice and this permission notice shall be included in
   all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
   THE SOFTWARE.
 -->
<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 2L10.0215 3.91211L7.29883 3.52734L6.82227 6.23828L4.39258 7.52734L5.59961 10L4.39258 12.4727L6.82227 13.7617L7.29883 16.4727L10.0234 16.0879L12 18L13.9785 16.0879L16.7031 16.4727L17.1777 13.7617L19.6094 12.4727L18.4004 10L19.6074 7.52734L17.1777 6.23828L16.7012 3.52734L13.9766 3.91211L12 2ZM4.98242 15.0176L1 19L4 20L5 23L9.58984 18.4102L9.34375 18.1758L8.11719 18.3477C7.99719 18.3647 7.87972 18.373 7.76172 18.373C6.52572 18.373 5.47277 17.4885 5.25977 16.2715L5.04688 15.0527L4.98242 15.0176ZM19.0176 15.0176L18.9531 15.0527L18.7402 16.2715C18.5262 17.4895 17.4743 18.373 16.2383 18.373C16.1203 18.373 16.0028 18.3647 15.8828 18.3477L14.6562 18.1758L14.4102 18.4121L19 23L20 20L23 19L19.0176 15.0176Z"
    />
  </g>
</template>
